// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/76dcc946/" + chunkId + "." + __webpack_require__.h() + ".v76dcc946.js";
};